// @ts-check
import React, { lazy, Suspense, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SplashScreen from "../../pages/splachscreen/page";
import { getStudy } from "../../service/study.service";
import { getInform } from "../../service/informs.service";
const Visor = lazy(() => import("../NuevoVisor/Visor"));
//const Visor2 = lazy(() => import("../../pages/dicomwebviewer/page"));

function Local() {
  const { id } = useParams();
  const [study, setstudy] = useState(
    /** @type {import("../../models/studies/study").default | null} */ (null),
  );
  const [inform, setinform] = useState(
    /** @type {import("../../models/studies/report").ReportItem[] | null} */ (
      null
    ),
  );
  const [ready, setready] = useState(false);
  useEffect(() => {
    (async () => {
      if (!id) return;
      setready(false);
      /** @type {[Promise<import("../../models/studies/study").default>, Promise<import("../../models/studies/report").ReportItem[]>]}*/
      const promise = [getStudy(id), getInform(id)];
      const [estudio, informe] = await Promise.all(promise);
      setstudy(estudio);
      setinform(informe);
      setready(true);
    })();
  }, [id]);
  return (
    <Suspense fallback={<SplashScreen message="Inicializando Visor" />}>
      {ready && study && inform ? (
        <Visor estudio={study} informe={inform} extern={false} />
      ) : (
        <SplashScreen message="Cargando Componentes" />
      )}
    </Suspense>
  );
}

export default Local;
